<template>
  <h1>DIS NFL survivor!</h1>
  <main>
    <div v-for="user in data" :key="user.username" class="user">
      <h4>
        <span v-if="user.eliminated" class="skull">💀 </span>
        <span :class="{ eliminated: user.eliminated }">{{ user.username }}</span>
      </h4>
      <SurvivorPick v-for="pick in user.picks" :key="pick.week" :pick="pick" />
    </div>
  </main>
</template>

<script>
import { fetchData } from '@/utils/fetchData.js'

import SurvivorPick from '@/components/SurvivorPick.vue'
export default {
  name: 'App',
  components: {
    SurvivorPick
  },
  data: function () {
    return {
      data: null
    }
  },
  methods: {
    fetchData: async function () {
      const data = await fetchData()
      this.data = data
    },
    logoUrl: function (team) {
      if (team === 'WSH') team = 'WAS'
      if (team === 'LAR') team = 'LA'
      return `https://static.nfl.com/static/content/public/static/wildcat/assets/img/logos/teams/${team}.svg`
    }
  },
  mounted: function () {
    this.fetchData()
  }
}
</script>

<style>
:root {
  font-size: 14px;
}

body {
  margin: 0 auto;
  max-width: 1000px;
  padding: 2rem;
}

h1 {
  margin: 0 0 1.5rem;
}

h4 {
  margin: 0;
  margin-bottom: .5em;
}

main {
  display: grid;
  grid-gap: 2em 4em;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}

.user {
  /*margin-bottom: 2em;*/
}

.eliminated {
  text-decoration: line-through;
}

.skull {
  font-size: 1.25em;
}
</style>
